import { initializeApp, deleteApp } from "firebase/app";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyADBEOhdK2kUwUzXhPt4tCnFMWHSPVLChw",
  authDomain: "vita-platform-47551.firebaseapp.com",
  projectId: "vita-platform-47551",
  storageBucket: "vita-platform-47551.firebasestorage.app",
  messagingSenderId: "680638964862",
  appId: "1:680638964862:web:bf9a3199dd1d06e90e242f"
};

// Crea el usuario cliente Y su documento en 'users',
// todo dentro de una conexión temporal, sin deslogear al admin.
export async function createClientUser(email, password, projectId) {
  const tempApp = initializeApp(firebaseConfig, "tempClientCreator-" + Date.now());
  const tempAuth = getAuth(tempApp);
  const tempDb = getFirestore(tempApp);

  try {
    const userCredential = await createUserWithEmailAndPassword(tempAuth, email, password);
    const uid = userCredential.user.uid;

    // Escribir el documento del usuario DESDE la conexión temporal,
    // que está autenticada como el cliente recién creado (escribe su propio doc).
    await setDoc(doc(tempDb, 'users', uid), {
      Rol: 'cliente',
      email: email,
      activo: true,
      proyectosPermitidos: [projectId]
    });

    return uid;
  } finally {
    await deleteApp(tempApp);
  }
}